import { SearchInput } from '../shared';
import { ProjectStatus, SortOrder, StartProjectDetailListSortType } from '../enums';

export class GetStartProjectDetailsInput extends SearchInput<StartProjectDetailListSortType> {
    public projectStatus: ProjectStatus | null = null;
    public customerId: number | null = null;
    public projectId: number | null = null;
    public assignedEmployeeId: number | null = null;

    constructor() {
        super(StartProjectDetailListSortType.Id);
        this.sortOrder = SortOrder.Descending;
    }
}
